module.exports = __webpack_public_path__ + "static/trees-3.5-388d632090dea40775ec358c7facbde5.png";